import React, { useState } from 'react';
import { CLIENT_TYPES } from '@/lib/constants';
import { X } from 'lucide-react';

export default function StageChangeModal({ contact, newStage, onClose, onConfirm }) {
    const isWon = newStage === 'Closed Won';
    const [clientType, setClientType] = useState(contact.client_type || 'buyer');
    const [transactionValue, setTransactionValue] = useState(contact.total_transaction_value_aed || '');
    const [leaseStart, setLeaseStart] = useState(contact.lease_start_date || '');
    const [leaseEnd, setLeaseEnd] = useState(contact.lease_end_date || '');
    const [monthlyRent, setMonthlyRent] = useState(contact.monthly_rent_aed || '');
    const [lostReason, setLostReason] = useState('');

    const submit = (e) => {
        e.preventDefault();
        if (isWon) {
            const extra = { client_type: clientType, total_transaction_value_aed: Number(transactionValue) || 0, is_client: true };
            if (clientType === 'tenant') {
                extra.lease_start_date = leaseStart || null;
                extra.lease_end_date = leaseEnd || null;
                extra.monthly_rent_aed = Number(monthlyRent) || null;
            }
            onConfirm(extra);
        } else {
            onConfirm({ lost_reason: lostReason, lost_at: new Date().toISOString() });
        }
    };

    return (
        <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
            <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6" data-testid="stage-change-modal">
                <div className="flex items-center justify-between mb-1">
                    <h2 className="text-lg font-bold text-aks-text">{isWon ? '🎉 Closed Won' : 'Closed Lost'}</h2>
                    <button type="button" onClick={onClose} className="text-gray-400 hover:text-aks-text"><X className="h-5 w-5"/></button>
                </div>
                <p className="text-[13px] text-gray-500 mb-4">{contact.full_name} — {isWon ? 'capture deal details' : 'why was this lost?'}</p>
                {isWon ? (
                    <div className="space-y-3">
                        <div>
                            <label className="text-[12px] font-medium text-aks-text">Client type *</label>
                            <div className="mt-1 grid grid-cols-3 gap-2">
                                {CLIENT_TYPES.map((t) => (
                                    <button type="button" key={t} onClick={() => setClientType(t)} className={`h-10 rounded-md border text-[12px] capitalize font-semibold transition ${clientType === t ? 'border-aks-gold bg-aks-gold-soft text-aks-navy' : 'border-gray-300 text-gray-600 hover:border-aks-gold/60'}`}>{t}</button>
                                ))}
                            </div>
                        </div>
                        <div>
                            <label className="text-[12px] font-medium text-aks-text">Transaction value (AED)</label>
                            <input type="number" value={transactionValue} onChange={(e) => setTransactionValue(e.target.value)} className="mt-1 w-full h-11 px-3 rounded-md border border-gray-300 outline-none focus:border-aks-gold aks-focus-ring text-[14px]" placeholder="e.g. 1500000" data-testid="won-value" />
                        </div>
                        {clientType === 'tenant' && (
                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <label className="text-[12px] font-medium">Lease start</label>
                                    <input type="date" value={leaseStart} onChange={(e) => setLeaseStart(e.target.value)} className="mt-1 w-full h-11 px-3 rounded-md border border-gray-300" />
                                </div>
                                <div>
                                    <label className="text-[12px] font-medium">Lease end</label>
                                    <input type="date" value={leaseEnd} onChange={(e) => setLeaseEnd(e.target.value)} className="mt-1 w-full h-11 px-3 rounded-md border border-gray-300" />
                                </div>
                                <div className="col-span-2">
                                    <label className="text-[12px] font-medium">Monthly rent (AED)</label>
                                    <input type="number" value={monthlyRent} onChange={(e) => setMonthlyRent(e.target.value)} className="mt-1 w-full h-11 px-3 rounded-md border border-gray-300" />
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <div>
                        <label className="text-[12px] font-medium text-aks-text">Reason *</label>
                        <textarea required value={lostReason} onChange={(e) => setLostReason(e.target.value)} rows={3} className="mt-1 w-full p-3 rounded-md border border-gray-300 outline-none focus:border-aks-gold aks-focus-ring text-[14px]" placeholder="Budget mismatch, went with competitor, etc." data-testid="lost-reason" />
                    </div>
                )}
                <div className="mt-6 flex gap-3">
                    <button type="button" onClick={onClose} className="flex-1 h-11 rounded-md border border-gray-300 text-[14px] font-medium hover:bg-gray-50">Cancel</button>
                    <button type="submit" className={`flex-1 h-11 rounded-md text-[14px] font-semibold ${isWon ? 'bg-aks-success text-white' : 'bg-aks-danger text-white'}`} data-testid="confirm-stage">{isWon ? 'Confirm Won' : 'Mark Lost'}</button>
                </div>
            </form>
        </div>
    );
}
